import React from 'react'
import { PALETTE } from '../../styles/constants'

function CheckmarkIcon({ width = 24, height = 24, color = PALETTE.gray80, opacity = '1' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none">
      <g opacity={opacity} clipPath="url(#clip0_2352_946)">
        <path d="M10.25 18L3.5 11.25L4.5605 10.1895L10.25 15.8782L20.4395 5.68945L21.5 6.74995L10.25 18Z" fill={color}/>
      </g>
      <defs>
        <clipPath id="clip0_2352_946">
          <rect width={width} height={height} fill="white" transform="translate(0.5)"/>
        </clipPath>
      </defs>
    </svg>

  )
}

export default CheckmarkIcon
